import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const PlusSource = {
  fetchInstallRequestStatus: function() {
    return { installRequestStatus: localStorage.getItem('installRequestStatus') }
  },

  requestInstallation: function(description) {
    localStorage.setItem('installRequestStatus', description)

    return this.fetch()
  },

  localStorage: function() {
    return { ...this.fetchInstallRequestStatus() }
  },

  mergeWithLocalStorage: function(data) {
    return { ...data, ...this.localStorage() }
  },

  fetch: function() {
    return axios.get(`${API_BASE}/plus`)
      .then(resp => {
        return this.mergeWithLocalStorage(resp.data)
      })
  },

  fetchRaw: function() {
    return axios.get(`${API_BASE}/plus`)
      .then(resp => {
        return resp.data
      })
  },

  upgrade: function() {
    return axios.put(`${API_BASE}/plus`, {}, { catchErrors: false })
      .then(resp => this.mergeWithLocalStorage(resp.data))
  },

  install: function(include = false) {
    const params = include ? { include: true } : {}
    return axios.post(`${API_BASE}/plus`, params, { catchErrors: false })
      .then(resp => this.mergeWithLocalStorage(resp.data))
  },

  downgrade: function() {
    return axios.delete(`${API_BASE}/plus`).then(res => res)
  }
}

export default PlusSource



// WEBPACK FOOTER //
// ./app/sources/PlusSource.js